import { Directive } from '@angular/core';
import { PropertyType } from 'src/app/models/enums/property-type';
import { AttributeDefinition } from 'src/app/models/server/attribute-definition';
import { BaseDirective } from './base.directive';

@Directive({
    standalone: false
})
export abstract class AttributeFilterBaseDirective extends BaseDirective {
    constructor() {
        super();
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de l'attribut est standard (texte ou nombre).
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de l'attribut est standard (texte ou nombre); false autrement.
     */
    public isStandardInput(attribute: AttributeDefinition): boolean {
        return (
            attribute.type === PropertyType.Text ||
            attribute.type === PropertyType.Long ||
            attribute.type === PropertyType.Decimal ||
            attribute.type === PropertyType.Email ||
            attribute.type === PropertyType.PhoneNumber ||
            attribute.type === PropertyType.Link
        );
    }

    /** Retourne une valeur indiquant si le type est liste */
    public isListInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.List || attribute.type === PropertyType.ListCustomers || attribute.type === PropertyType.ListUsers;
    }

    /** Retourne une valeur indiquant si le type de saisie du filtre de l'attribut est de l'autocomplétion pâr une API */
    public isAutocompletionByApiInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.AutocompletionByApi;
    }

    /**
     * Retourne une valeur indiquant si le type est enum
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de l'attribut est enum; false autrement.
     * */
    public isEnumInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.Enum;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de l'attribut est de type date.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de l'attribut est de type date; false autrement.
     */
    public isDateInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.Date;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de l'attribut est de type date & heure.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de l'attribut est de type date & heure; false autrement.
     */
    public isDateAndTimeInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.DateAndTime;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de l'attribut est de type color.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de l'attribut est de type  Color; false autrement.
     */
    public isColorInput(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.Color;
    }

    /**
     * Retourne une valeur indiquant si l'attribut est de type Workflow.
     * @param attribute : Attribut.
     * @returns : true si l'attribut est de type Workflow.; false autrement.
     */
    public isWorkflow(attribute: AttributeDefinition): boolean {
        return attribute.type === PropertyType.Workflow;
    }
}
